/**
 * Stripe class
 * @constructor
 */
class Stripe{

    constructor(data) {
        this.data = data;
        this.container = $("<div>").appendTo("#preview-container");
        this.container.addClass("marquee");
    }

    /**
     * RSS refresh timer instance
     * @type {null}
     */
    refreshTimer = null;

    /**
     * Start stripe
     */
    start() {
        console.debug("Start stripe");
        try {
            if(this.data.stripe.mediaType === "text") {         // simple stripe
                this._showStripe(this.data.stripe.content);
            } else {                                            // RSS
                this._prepareRSS(this.data.stripe.content, this.data.refresh);
                //this._showStripe("RSS: " + this.data.stripe.content);
                console.debug("RSS: " + JSON.stringify(this.data));
            }
        } catch (e) {
            console.error("Stripe start error: " + e.message);
        }
    };

    /**
     * Parse RSS
     * @param rssUrl
     * @param refreshInterval
     * @private
     */

    _prepareRSS(rssUrl, refreshInterval) {
        var self = this;
        // initialize timer
        this.refreshTimer = setTimeout(this._prepareRSS.bind(this), refreshInterval * 1000, rssUrl, refreshInterval);
        $.ajax({
            url: rssUrl,
            dataType: "xml",
            success: function(xml){
                console.log("Got RSS XML source");
                let textString = "";
                let titles = [];
                const items = $(xml).find("item");
                console.log("RSS items count " + items.length);
                for(let itemId = 0; itemId < items.length; itemId++){
                    const item = $(items[itemId]);
                    const itemTitle = item.find("title").text();
                    // console.debug("RSS title: " + itemTitle);
                    const itemDescription = item.find("description").text();
                    titles.push(itemTitle);
                    // textString += " | " + itemTitle;
                    // textString += "&nbsp;&nbsp;&nbsp;&#xb7;&nbsp;&nbsp;&nbsp;" + itemTitle;
                    //textString += " <b>&#xb7; " + itemTitle + "</b>: " + itemDescription;
                    // if(textString.length > 4000){ break; }
                }
                textString = titles.join("&nbsp;&nbsp;&nbsp;&#xb7;&nbsp;&nbsp;&nbsp;");
                self._showStripe(textString);
            },
            error: function (q,w,e) {
                console.error("RSS download error: " + e);
            }
        });
    }

    /**
     * Display stripe
     * @param text
     * @private
     */
    _showStripe(text){
        console.log("Starting stripe");
        this.container.html(text)
            .css({"color": this.data.color, "background-color": this.data.background});
        this.container.marquee({duration: 20000});
        // this.container.liMarquee();
    }

    stop() {
        try {
            console.log("Stopping stripe");
            if(this.container.text().length > 0) {
                this.container.text("")                         // empty marquee text
                    .css("background-color", "transparent");
                this.container.marquee("destroy");           // destroy marquee
            }

            if(this.refreshTimer){
                console.log("Clear timeout RSS refresh");
                clearTimeout(this.refreshTimer);                // stop timer
            }

        } catch (e) {
            console.error("Stripe stop error: " + e.message);
        }
    };
}
